// extracted by mini-css-extract-plugin
export var ratingTitle = "UserReview-module--ratingTitle--50111";
export var reviewCountContent = "UserReview-module--reviewCountContent--f7b15";
export var reviewCountTitle = "UserReview-module--reviewCountTitle--66fbb";
export var reviewHeader = "UserReview-module--reviewHeader--1757b";
export var reviewIcons = "UserReview-module--reviewIcons--5c9e8";